import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';

import { RtAnalyticsModule } from '@recruitee/analytics';
import { DetachedRouterModule } from '@recruitee/common';
import { UIRootProviders } from '@recruitee/user-interface';

import { AppComponent } from './app.component';
import { AUTH_ROUTES } from './auth-routes';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    DetachedRouterModule,
    CommonModule,
    HttpClientModule,
    RtAnalyticsModule.forRoot({
      disable: true,
      segmentKey: '',
      trackRouteChange: false,
    }),
  ],
  providers: [provideRouter(AUTH_ROUTES), UIRootProviders()],
  bootstrap: [AppComponent],
})
export class AppModule {}
